/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'jquery-once/jquery.once';
import 'webpack-jquery-ui/effects';
// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/lazysizes';
import 'jquery-match-height/dist/jquery.matchHeight';
import 'slick-carousel/slick/slick';
// import 'aos/dist/aos';
// import 'venobox/venobox/venobox';
import 'mmenu-light/dist/mmenu-light';
// import 'nicescroll/dist/jquery.nicescroll';
// import jQueryBridget from 'jquery-bridget';
// import InfiniteScroll from 'infinite-scroll';

/**
 * Local Dependencies
 */
import './plugins.js';

/**
 * Use jQueryBridget to use the function from the .pkgd file.
 * Example: infinite-scroll, Masonry, imagesLoaded
 */
// jQueryBridget('infiniteScroll', InfiniteScroll);

const $win = $(window);
const $doc = $(document);

const triggerLoading = () => {
  $('.loader').fadeTo(400, 0);
  $('header.header').fadeTo(400, 1);
  $('main.main-wrapper').fadeTo(400, 1);
  $('footer.footer').fadeTo(400, 1);
  $('.pre-loader').hide();
}

// Hide show back to top links.
const backToTop = (el) => {
  if ($win.scrollTop() > 300) {
    $(el).fadeIn();
  } else {
    $(el).fadeOut();
  }

  $(el).once('backtotop').each(function () {
    $(this).click(function () {
      $('html, body').bind('scroll mousedown DOMMouseScroll mousewheel keyup', function () {
        $('html, body').stop();
      });
      $('html,body').animate({scrollTop: 0}, 1200, 'easeOutQuart', function () {
        $('html, body').unbind('scroll mousedown DOMMouseScroll mousewheel keyup');
      });
      return false;
    });
  });
};

function mmenu_load() {
  // mmenu-js (reload the page on 992 max width below to see the effect.)
  if (window.matchMedia("(max-width: 991.98px)").matches) {
    if(!$('.mm-ocd.mm-ocd--left').length) {
      var mainmenu_nav = $('#navbarToggler');
      var clone = mainmenu_nav.before(mainmenu_nav.clone());
      clone.attr('id', 'mmenu-app');
      //clean up mmenu by removing bootstrap classes
      $('#mmenu-app').removeAttr('class');
      $('#mmenu-app').find('ul').removeClass('navbar-nav nav dropdown-menu animated fadeInDown').removeAttr('id');
      $('#mmenu-app').find('li').removeClass('nav-item dropdown dropdown-item');
      $('#mmenu-app').find('li a').removeClass('nav-link dropdown-toggle').removeAttr('data-toggle data-target id');
      const menu = new MmenuLight(
        document.querySelector( "#mmenu-app" )
      );

      const navigator = menu.navigation({
        selectedClass: 'Selected',
        slidingSubmenus: true,
        theme: 'light',
        // title: 'Menu'
      });

      const drawer = menu.offcanvas({
        position: 'left',
      });

      var mm_logo = $('header .site-logo-link img');

      //	Open the menu.
      document.querySelector( 'a[href="#mmenu-app"]' ).addEventListener( 'click', evnt => {
        evnt.preventDefault();
        // Append Site Logo
        if(!$('.mmenu-header-logo').length) {
          mm_logo.clone().addClass('mmenu-header-logo').appendTo('.mm-ocd--left #mmenu-app');
        }
        drawer.open();
      });

      // Append close button
      var close_btn_element = '<button type="button" class="close mmenu-light-closebtn" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
      $('.mm-ocd--left #mmenu-app').append(close_btn_element);
      
      document.querySelector( '.mmenu-light-closebtn' ).addEventListener( 'click', evnt => {
        evnt.preventDefault();
        drawer.close();
      });
    }
  }
}

$(() => {
  // CF7 validation events for changing response CSS classes
  document.addEventListener( 'wpcf7invalid', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-danger');
  }, false );
  document.addEventListener( 'wpcf7spam', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
  }, false );
  document.addEventListener( 'wpcf7mailfailed', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
  }, false );
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-success');
  }, false );

  mmenu_load();

  // match-height
  $('.match-height').matchHeight();

  $('.slick-carousel').slick_slider({
    dots:false,
    arrows:false,
  });

  $('.slick-slideshow').slick_slideshow({
    dots:false,
    arrows:true,
  });
  
  $win.on('scroll', () => {
    var headerHeight = $(".nav-top").outerHeight();
    if($doc.scrollTop() > headerHeight){
      // console.log("fixed");
      $('.nav-bottom').addClass('sticky-header');
      $('.header').addClass('sticky-header-top');
    }else{
      // console.log("remove fixed");
      $('.nav-bottom').removeClass('sticky-header');
      $('.header').removeClass('sticky-header-top');
    }

    backToTop('#back2top');
  });
  /*
  * Window Resize
  */
  $win.on('resize', function () {
    // match-height
    $('.match-height').matchHeight();
  });
});

$win.on('load', () => {
  setTimeout(() => {
    triggerLoading();
  }, 1000);

  backToTop('#back2top');
});
